<template>
  <div class="main">
    <div class="container">
      <div class="card-list">
        <div class="card-item-first" v-if="starData">
          <div class="card-left">
            <div class="card-left-title">
              我的星币
            </div>
            <div class="card-left-content">
              <img src="@/assets/image/starCoin/starCoin@2x.png" alt="" />
              {{ starData.currentStarNum }}
            </div>
          </div>
          <div class="card-right">
            <!-- <div class="card-right-title">
              今日新增星币
            </div>
            <div class="card-right-content">
              {{ starData.todayStarNum }}
            </div> -->
            <div
              v-if="$store.state.user.schoolInfo.pointAuth"
              class="starCoin-rank"
              @click="
                $router.push({
                  name: 'stuStarCoinRank',
                  query: { type: 'starCoin' },
                })
              "
            >
              <img src="@/assets/image/stuUI/stuDetailIcon@2x.png" alt="" />
              <span>星币排行</span>
            </div>
          </div>
        </div>
        <!-- 第二个开始 -->
        <div
          class="card-item"
          v-for="cardItem in cardDataList"
          :key="cardItem.id"
          v-show="!cardItem.hide"
        >
          <div class="card-left">
            <div class="card-left-title">
              {{ cardItem.title }}
            </div>
            <div class="card-left-content">
              <div>
                <img src="@/assets/image/starCoin/starCoin@2x.png" alt="" />
                <strong>{{ cardItem.coinNum }}</strong>
              </div>
            </div>
          </div>
          <!-- <div class="card-right">
            <img :src="cardItem.img" alt="" />
          </div> -->
        </div>
      </div>
      <div class="tabs">
        <div
          v-for="tabPane in tabsData.list"
          :key="tabPane.value"
          :class="{ 'tab-pane': 1, active: tabsData.value === tabPane.value }"
          @click="methodChangeTab(tabPane.value)"
        >
          {{ tabPane.label }}
        </div>
      </div>
      <div class="tab-content" v-if="starData">
        <!-- 传入myStarNum 我的星币数量 -->
        <template v-if="tabsData.value === '1'">
          <goodsExchange
            :pageInfo="page"
            @returnPage="getPageInfo"
            :myStarNum="starData.currentStarNum"
          />
        </template>
        <template v-if="tabsData.value === '2'">
          <exchangeRecord
            :pageInfo="page"
            @returnPage="getPageInfo"
            :myStarNum="starData.currentStarNum"
          />
        </template>
        <template v-if="tabsData.value === '3'">
          <fetchRecord
            :pageInfo="page"
            @returnPage="getPageInfo"
            :myStarNum="starData.currentStarNum"
          />
        </template>
        <template v-if="tabsData.value === '4'">
          <myGoods
            :pageInfo="page"
            @returnPage="getPageInfo"
            :myStarNum="starData.currentStarNum"
          />
        </template>
      </div>
      <div class="pagination">
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.currentPage"
            background
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.pagSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入请求
import {
  api_stuStuStarPersonalSoa,
  api_stuEduCampusStarRule,
} from '@/api/javaApi'
// 引入组件
import goodsExchange from './goodsExchange.vue'
import exchangeRecord from './exchangeRecord.vue'
import fetchRecord from './fetchRecord.vue'
import myGoods from './myGoods.vue'

export default {
  name: 'stuStarCoinCenter',
  components: {
    goodsExchange,
    exchangeRecord,
    fetchRecord,
    myGoods,
  },
  data() {
    return {
      starData: null,
      cardDataList: [
        {
          id: 1,
          title: '',
          label: '',
          coinNum: 0,
          img: require('@/assets/image/starCoin/cardIcon1@2x.png'),
          hide: true,
        },
        {
          id: 2,
          title: '',
          label: '',
          coinNum: 0,
          img: require('@/assets/image/starCoin/cardIcon2@2x.png'),
          hide: true,
        },
        {
          id: 3,
          title: '',
          label: '',
          coinNum: 0,
          img: require('@/assets/image/starCoin/cardIcon3@2x.png'),
          hide: true,
        },
        {
          id: 4,
          title: '',
          label: '',
          coinNum: 0,
          img: require('@/assets/image/starCoin/cardIcon4@2x.png'),
          hide: true,
        },
      ],
      tabsData: {
        value: '1',
        list: [
          { label: '商品兑换', value: '1' },
          { label: '兑换记录', value: '2' },
          { label: '星币明细', value: '3' },
          { label: '我的商品', value: '4' },
        ],
      },
      formParams: {},
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
        update: false,
      },
    }
  },
  async created() {
    await this.stuEduCampusStarRule()
    this.stuStuStarPersonalSoa()
  },
  methods: {
    methodChangeTab(tab) {
      this.tabsData.value = tab
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.page.currentPage = 1
      this.page.update = true
    },
    handleCurrentChange(page) {
      this.page.currentPage = page
      this.page.update = true
    },
    // 子组件返回的页码信息
    getPageInfo(page) {
      console.log(page)
      this.page = {
        ...this.page,
        ...page,
      }
    },
    // 星币信息
    stuStuStarPersonalSoa() {
      api_stuStuStarPersonalSoa({
        stuId: this.$store.state.user.userInfo.id,
        eduCampusId: this.$store.state.user.userInfo.eduCampusId,
      }).then((res) => {
        console.log(res)
        this.starData = res
        res.resultList.forEach((item, i) => {
          this.cardDataList[i].label = this.cardDataList[i].title = item.name
          this.cardDataList[i].coinNum = item.num
          this.cardDataList[i].hide = false
        })
      })
    },
    // 学生端星币规则查询
    async stuEduCampusStarRule() {
      return api_stuEduCampusStarRule({
        eduCampusId: this.$store.state.user.userInfo.eduCampusId,
        ruleType: 0,
      })
    },
  },
}
</script>
<style scoped lang="scss">
.main {
  padding: 20px;
  .container {
    max-width: 1500px;
    min-width: 1180px;
    margin: auto;
    .card-list {
      display: flex;
      // flex-wrap: wrap;
      .card-item-first {
        flex: 1;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        width: 370px;
        min-width: 260px;
        // max-width: calc(36.8% + 15px);
        max-width: 40.8%;
        padding: 25px;
        margin-right: 15px;
        margin-bottom: 20px;
        background: #ffffff;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 24px;
        .card-left {
          .card-left-title {
            font-weight: 400;
            font-size: 20px;
            color: #0a1629;
            margin-bottom: 10px;
          }
          .card-left-content {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 24px;
            color: #333333;
            line-height: 33px;
            img {
              display: block;
              width: 50px;
              margin-right: 20px;
              font-weight: 500;
              font-size: 24px;
              color: #333333;
              line-height: 33px;
            }
          }
        }
        .card-right {
          .starCoin-rank {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            margin-right: 20px;
            cursor: pointer;
            img {
              width: 50px;
            }
            span {
              padding-top: 10px;
            }
          }
          .card-right-title {
            margin-bottom: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #7d8592;
            line-height: 24px;
          }
          .card-right-content {
            font-weight: 400;
            font-size: 24px;
            color: #0a1629;
          }
        }
      }
      .card-item {
        box-sizing: border-box;
        display: flex;
        width: 18.4%;
        padding: 25px;
        margin-right: 15px;
        margin-bottom: 20px;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 24px;
        &:last-child {
          margin-right: 0;
        }
        &:nth-child(2) {
          background: #fff
            url('../../../assets/image/starCoin/cardIcon1@2x.png') 88% center /
            auto 90px no-repeat;
        }
        &:nth-child(3) {
          background: #fff
            url('../../../assets/image/starCoin/cardIcon2@2x.png') 88% center /
            auto 90px no-repeat;
        }
        &:nth-child(4) {
          background: #fff
            url('../../../assets/image/starCoin/cardIcon3@2x.png') 88% center /
            auto 90px no-repeat;
        }
        &:nth-child(5) {
          background: #fff
            url('../../../assets/image/starCoin/cardIcon4@2x.png') 88% center /
            auto 90px no-repeat;
        }
        .card-left {
          // margin-right: 45px;
          .card-left-title {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            min-width: 80px;
            height: 29px;
            margin-bottom: 10px;
            background: #5b4eda;
            border-radius: 15px;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
          }
          .card-left-content {
            span {
              font-weight: 400;
              font-size: 18px;
              color: #0a1629;
              line-height: 26px;
            }
            div {
              display: flex;
              align-items: center;
              padding-top: 25px;
              font-weight: 500;
              font-size: 16px;
              color: #333333;
              line-height: 22px;
              img {
                display: block;
                width: 20px;
              }
              strong {
                padding-left: 5px;
              }
            }
          }
        }
        .card-right {
          img {
            display: block;
            width: 90px;
          }
        }
      }
    }
    .tabs {
      padding: 0 40px;
      margin-bottom: 20px;
      background: #ffffff;
      border-radius: 10px;
      .tab-pane {
        position: relative;
        display: inline-flex;
        align-items: center;
        height: 64px;
        margin-right: 60px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        transition: all 0.25s;
        cursor: pointer;
        &::after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 50%;
          transform: translateX(-50%);
          width: 0px;
          height: 3px;
          background: #1678ff;
          border-radius: 3px;
          transition: width 0.15s;
        }
        &:hover {
          color: #1578ff;
        }
        &.active {
          font-weight: bold;
          color: #1578ff;
          &::after {
            width: 35px;
          }
        }
      }
    }
    .tab-content {
      margin-bottom: 70px;
    }
    .pagination {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 9;
      width: 100%;
      background: rgba(255, 255, 255, 0.95);
      box-shadow: inset 1px 1px 0px 0px #ebedf0;
      .pagination-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        max-width: 1680px;
        height: 70px;
        padding: 0 50px;
        margin: auto;
        .el-pagination {
        }
      }
    }
  }
}
</style>
